import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=aeb9fe64&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb9fe64",
  null
  
)

export default component.exports